import { createSlice } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { initialStore } from '../initial-store';

// Slices

const questionnairesSlice = createSlice({
  name: 'questionnaires',
  initialState: initialStore.questionnaires,
  reducers: {
    getQuestionnaires: (state) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setQuestionnairesData: (state, { payload }) => {
      state.isLoading = false;
      state.allQuestionnaires = payload;
    },
    getQuestionnairesFail: (state) => {
      state.isLoading = false;
    }
  }
});

export const {
  getQuestionnaires,
  setQuestionnairesData,
  getQuestionnairesFail
} = questionnairesSlice.actions;

export const { reducer } = questionnairesSlice;

// Selectors
export const getAllQuestionnairesSelector = (state: IState) =>
  state && state.questionnaires.allQuestionnaires;
